<template>
    <div class="flex w-full rounded-lg item-center shadow cursor-pointer p-3" @click="clickFile">
        <div class="flex  justify-center pr-3 ">
            <!-- <feather-icon icon="FileIcon" class="inline-block" svgClasses="w-10 h-10 text-primary" /> -->
           <img class="w-10" src="/images/file-icons/pdf.png">
        </div>
        <div class="flex flex-1 flex-col justify-center">
            <div class="font-bold">Nama File Panjang Banget</div>
            <div class="text-sm">200kb</div>
        </div>
        <div class="flex items-center self-end">
            <div class="flex items-center rounded-lg bg-grey-100 p-3">
                <feather-icon icon="Edit3Icon" class="inline-block " svgClasses="w-5 h-5 text-primary " />
                <div class="ml-3">Isi TTE</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods : {
        clickFile(){
            this.$emit('clickFile',true)
        }
    }
}
</script>